import { createUser, getUsers } from "../api/userService";

export const useCreateUser = (setUsers) => {
    const create = async (data) => {
    try {
        const response = await createUser(data);
        const newUser = response;

        // Instead of appending, re-fetch the list
        const usersResponse = await getUsers();
        setUsers(usersResponse);

        return newUser; // still return the created record
    } 
    catch (error) {
        console.error("Error creating user:", error);
        throw error;
    }
  };

  return { create };
};